import Swiper, { Navigation, Pagination } from 'swiper';

export default () => {
    Swiper.use([Navigation, Pagination]);

    let moduleSlider = new Swiper('.js-slider-module', {
        spaceBetween: 20,
        slidesPerView: 'auto',
    });

    let bigSlider = new Swiper('.js-big-slider', {
        slidesPerView: 1,
        navigation: {
            nextEl: '.custom-swiper-button-next',
            prevEl: '.custom-swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
    });

    let logoSlider = new Swiper('.js-logo-slider', {
        slidesPerView: 2,
        spaceBetween: 40,
        navigation: {
            nextEl: '.custom-swiper-button-next',
            prevEl: '.custom-swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        breakpoints: {
            768: {
                slidesPerView: 4
            }
        }
    });

    let bigImageSlider = new Swiper('.js-big-image-slider', {
        navigation: {
            nextEl: '.custom-swiper-button-next',
            prevEl: '.custom-swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
    });
};